import ApiClient from './ApiClient';

class CrmConfigs extends ApiClient {
  constructor() {
    super('crm_configs', { accountScoped: true });
  }
}

export default new CrmConfigs();
